// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { StatusState } from "@/types/status";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Status } from "@/models/status";

const state: StatusState = {
  single: new Status(),
  pagination: new Pagination(),
};

export const status: Module<StatusState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
